export default __webpack_public_path__ + "1f879091cae5ab059fad8953e104387f.ttf";